import { render, staticRenderFns } from "./studyRecord.vue?vue&type=template&id=761e7d4a"
import script from "./studyRecord.vue?vue&type=script&lang=js"
export * from "./studyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports